import React from 'react'
import { Helmet } from 'react-helmet'

interface GetFaviconAssetsFunc {
  (pathToAssets: string, versionQuery: string): JSX.Element[]
}

const getFaviconAssets: GetFaviconAssetsFunc = (
  pathToAssets: string,
  versionQuery: string
): JSX.Element[] => {
  return [
    <link
      key="16x16"
      rel="icon"
      type="image/png"
      href={`${pathToAssets}/favicon-16x16-red.png${versionQuery}`}
      sizes="16x16"
    />,
    <link
      key="32x32"
      rel="icon"
      type="image/png"
      href={`${pathToAssets}/favicon-32x32-red.png${versionQuery}`}
      sizes="32x32"
    />,
    <link
      key="48x48"
      rel="icon"
      type="image/png"
      href={`${pathToAssets}/favicon-48x48-red.png${versionQuery}`}
      sizes="48x48"
    />,
    <link
      key="apple-touch"
      rel="apple-touch-icon"
      href={`${pathToAssets}/apple-touch-icon-red.png${versionQuery}`}
      type="image/png"
    />,
    <link
      key="manifest"
      rel="manifest"
      href={`${pathToAssets}/manifest.json${versionQuery}`}
    />,
  ]
}

const Favicons: React.FC<{ pathToAssets?: string; version?: string }> = ({
  pathToAssets = '',
  version = undefined,
}) => {
  const versionQuery = version != null ? `?v=${version}` : ''

  // Remove any trailing slash as the favicon paths explicitly contain one
  const normalisedAssetPath = pathToAssets.endsWith('/')
    ? pathToAssets.slice(0, -1)
    : pathToAssets

  return <Helmet>{getFaviconAssets(normalisedAssetPath, versionQuery)}</Helmet>
}

export default Favicons
